import { SectionHeader } from '../Shared/SectionHeader'
import { Section } from '../Shared/Section'
import { CatalogHealthCard } from './Cards/CatalogHealthCard'
import { TopProductsCard } from './Cards/TopProductsCard/TopProductsCard'

const OfferPerformanceSection = () => {

    return (
      <>
          <SectionHeader title={`Performance de l'offre`}/>

          <Section>
              <CatalogHealthCard />
              <TopProductsCard />
          </Section>
      </>
    )
}

export { OfferPerformanceSection }
